import { render } from "./RegisterForm.vue?vue&type=template&id=7cefbc1e&scoped=true&ts=true"
import script from "./RegisterForm.vue?vue&type=script&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&lang=ts"

import "./RegisterForm.vue?vue&type=style&index=0&id=7cefbc1e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cefbc1e"]])

export default __exports__